import React from 'react'
import { Redirect, Route } from 'react-router-dom'

// Sales agents (userType AGENT) only. Everyone else goes back to '/', which
// sends them to their own home.
export const AgentPrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props => {
      let user = null
      try { user = JSON.parse(localStorage.getItem('user-enatega')) } catch (e) { user = null }
      if (!user) return <Redirect to={{ pathname: '/auth/login', state: { from: props.location } }} />
      return user.userType === 'AGENT'
        ? <Component {...props} />
        : <Redirect to={{ pathname: '/', state: { from: props.location } }} />
    }}
  />
)
